export default "__VITE_ASSET__DdbgCOVC__"